import { useParams, Link } from 'react-router-dom';

export const PublicQuoteSuccessPage = () => {
  const { token } = useParams<{ token: string }>();

  return (
    <div
      className="container-main"
      style={{
        maxWidth: '600px',
        paddingTop: 'var(--space-16)',
        paddingBottom: 'var(--space-16)',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          borderRadius: 'var(--radius-xl)',
          border: '1px solid var(--border-default)',
          backgroundColor: 'var(--bg-surface)',
          padding: 'var(--space-8)',
        }}
      >
        {/* Success icon */}
        <div
          style={{
            width: '3.5rem',
            height: '3.5rem',
            borderRadius: 'var(--radius-full)',
            backgroundColor: 'var(--bg-success-subtle, rgba(34,197,94,0.08))',
            color: 'var(--color-success-600, #16a34a)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto var(--space-5)',
          }}
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2.5}
            style={{ width: '1.75rem', height: '1.75rem' }}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        </div>

        <h1
          style={{
            fontSize: 'var(--text-2xl)',
            fontWeight: 'var(--font-weight-bold)',
            color: 'var(--text-primary)',
            marginBottom: 'var(--space-3)',
          }}
        >
          Thank you! Your order has been placed.
        </h1>

        <p
          style={{
            color: 'var(--text-secondary)',
            fontSize: 'var(--text-sm)',
            lineHeight: 'var(--leading-relaxed)',
            maxWidth: '28rem',
            margin: '0 auto',
          }}
        >
          You will receive an email confirmation shortly with your order details
          and tracking information once your print is ready to ship.
        </p>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 'var(--space-3)',
            marginTop: 'var(--space-6)',
          }}
        >
          <Link
            to="/track-order"
            style={{
              fontSize: 'var(--text-sm)',
              color: 'var(--text-accent)',
              textDecoration: 'underline',
            }}
          >
            Track your order
          </Link>
          {token && (
            <Link
              to={`/q/${token}`}
              style={{
                fontSize: 'var(--text-sm)',
                color: 'var(--text-tertiary)',
                textDecoration: 'underline',
              }}
            >
              Back to quote
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};
